import { FC, SyntheticEvent } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Dialog from 'components/Dialog';
import RoomRatesEditorRoomSettings from 'components/RoomRatesEditorRoomSettings';

import { RoomRatesEditorSettingsMenuRooms_package$key } from '__generated__/RoomRatesEditorSettingsMenuRooms_package.graphql';

type Props = {
  package: RoomRatesEditorSettingsMenuRooms_package$key;
};

const RoomRatesEditorSettingsMenuRooms: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment RoomRatesEditorSettingsMenuRooms_package on Package {
        ...RoomRatesEditorRoomSettings_package
      }
    `,
    props.package
  );

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClick={(event: SyntheticEvent) => event.stopPropagation()}
      activateButton={open => (
        <MenuItem onClick={open}>
          <ListItemIcon>
            <RoomPreferencesIcon />
          </ListItemIcon>

          <ListItemText>Kambarių nustatymai</ListItemText>
        </MenuItem>
      )}>
      <RoomRatesEditorRoomSettings package={pack} />
    </Dialog>
  );
};

export default RoomRatesEditorSettingsMenuRooms;
